var view = {
  MOBILE: 1,
  TAB: 2,
  DESKTOP: 3,
};

export default view;

export const isValidViewMode = mode => Object.values(view).includes(mode);

var formView = {
  STEP_ONE: 1,
  STEP_TWO_SELLER: 2,
  STEP_TWO_HOTEL: 3,
  STEP_TWO_HOME: 4,
  STEP_THREE: 5
};

export var formView;

var validation = {
  PHONE_NUMBER: 1,
  HOTEL_EMAIL: 2,
  ROOM_COUNT: 3,
  LOCATION: 4,
  FULL_NAME: 5,
  HOTEL_PROPERTY_NAME: 6,
  HOME_ADDRESS: 7,
  HOME_STRUCTURE_TYPE: 8,
  SELLER_HOTEL_NAME: 9,
  SELLER_HOTEL_ADDRESS: 10,
  SELLER_NUMBER_OF_ROOMS: 11,
  LOCATION_OBJECT: 12,
  REVENUE_POTENTIAL: 13,
  HOTEL_PROPERTY_ADDRESS: 14,
};

export var validation;

var digits = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

export var digits;

var borders = {
  RED_BORDER: 'solid 1px red',
  NORMAL_BORDER: '1px solid rgba(0, 0, 0, 0.08)',
  ACTIVE_BORDER: '1px solid rgba(0, 0, 0, 0.5)'
};

export var borders;

var propertyType = {
  HOTEL: 1,
  HOME: 2,
  LIFE: 3,
};

export var propertyType;

var defaultValues = {
  number_of_rooms: 20
};

export var defaultValues;

var revenueView = {
  clickToSee: 1,
  loading: 2,
  noData: 3,
  yesData: 4
};

export var revenueView;

var oyoFormView = {
  checkEarnings: 1,
  otpScreen: 2,
  signUpScreen: 3,
  loginScreen: 4,
  hotelBasic: 5,
  homeBasic: 6,
  forgotPassword: 7,
  homeStepTwo: 8,
  hotelStepTwo: 9,
  loginWithOtpStepOne:10,
  loginWithOtpStepTwo:11,
  lifeBasic:12,
  hmsSelfOnboardingHome:13,
};

export var oyoFormView;

var oyoFormHeights = {};
oyoFormHeights['height'] = {};
oyoFormHeights['height'][view.DESKTOP] = {
  [oyoFormView.checkEarnings]: 340,
  [oyoFormView.otpScreen]: 345,
  [oyoFormView.signUpScreen]: 495,
  [oyoFormView.loginScreen]: 380,
  [oyoFormView.hotelBasic]: 360,
  [oyoFormView.homeBasic]: 420,
  [oyoFormView.homeStepTwo]: 425,
  [oyoFormView.forgotPassword]: 340,
  [oyoFormView.hotelStepTwo]: 350,
  [oyoFormView.loginWithOtpStepOne]:305,
  [oyoFormView.loginWithOtpStepTwo]:425,
  [oyoFormView.lifeBasic]:300,
  [oyoFormView.hmsSelfOnboardingHome]:217
};
oyoFormHeights['height'][view.MOBILE] = {
  [oyoFormView.checkEarnings]: 340,
  [oyoFormView.otpScreen]: 335,
  [oyoFormView.signUpScreen]: 475,
  [oyoFormView.loginScreen]: 380,
  [oyoFormView.hotelBasic]: 360,
  [oyoFormView.homeBasic]: 400,
  [oyoFormView.homeStepTwo]: 420,
  [oyoFormView.forgotPassword]: 340,
  [oyoFormView.hotelStepTwo]: 350,
  [oyoFormView.loginWithOtpStepOne]:305,
  [oyoFormView.loginWithOtpStepTwo]:410,
  [oyoFormView.lifeBasic]:300,
  [oyoFormView.hmsSelfOnboardingHome]:217
};

oyoFormHeights['bottom_extra'] = {};
oyoFormHeights['bottom_extra'][view.DESKTOP] = {
  [oyoFormView.checkEarnings]: 0,
  [oyoFormView.otpScreen]: 23,
  [oyoFormView.signUpScreen]: 21,
  [oyoFormView.loginScreen]: 15,
  [oyoFormView.hotelBasic]: 0,
  [oyoFormView.homeBasic]: 0,
  [oyoFormView.homeStepTwo]: 8,
  [oyoFormView.forgotPassword]: 0,
  [oyoFormView.hotelStepTwo]: 0,
  [oyoFormView.loginWithOtpStepOne]:15,
  [oyoFormView.loginWithOtpStepTwo]:15,
  [oyoFormView.lifeBasic]: 0,
  [oyoFormView.hmsSelfOnboardingHome]:0
};
oyoFormHeights['bottom_extra'][view.MOBILE] = {
  [oyoFormView.checkEarnings]: 0,
  [oyoFormView.otpScreen]: 23,
  [oyoFormView.signUpScreen]: 27,
  [oyoFormView.loginScreen]: 18,
  [oyoFormView.hotelBasic]: 0,
  [oyoFormView.homeBasic]: 0,
  [oyoFormView.homeStepTwo]: 8,
  [oyoFormView.forgotPassword]: 0,
  [oyoFormView.hotelStepTwo]: 0,
  [oyoFormView.loginWithOtpStepOne]:15,
  [oyoFormView.loginWithOtpStepTwo]:15,
  [oyoFormView.lifeBasic]: 0,
  [oyoFormView.hmsSelfOnboardingHome]:0
};

export var oyoFormHeights;

var carouselMode = {
  HOTEL: 1,
  SIGN_UP: 2,
  HOME: 3
};

export var carouselMode;
